import PropTypes from 'prop-types';

export const calendarType = PropTypes.shape({
  schoolName: PropTypes.string,
  schoolYearStart: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
  integrationPending: PropTypes.bool,
  teachingPeriod: PropTypes.shape({ fromDate: PropTypes.string.isRequired, tillDate: PropTypes.string.isRequired }),
  breaks: PropTypes.arrayOf(PropTypes.shape({
    breakId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    fromDate: PropTypes.string.isRequired,
    tillDate: PropTypes.string.isRequired,
  })).isRequired,
});

export const displayDate = (date, language = 'pl') => date.split('-').reverse().join(language === 'en' ? '/' : '.');
export const displayRange = ({ fromDate, tillDate }, language) => (
  fromDate === tillDate ? displayDate(fromDate, language) : `${displayDate(fromDate, language)} — ${displayDate(tillDate, language)}`
);
export const sortedBreaks = breaks => [...breaks].sort((a, b) => (
  a.fromDate.localeCompare(b.fromDate) || a.tillDate.localeCompare(b.tillDate) ||
  a.name.localeCompare(b.name, 'pl') || a.breakId.localeCompare(b.breakId)
));
